export enum SportEventsNewQueryKeys {
  List = "sportEventsNew.list",
  Single = "sportEventsNew.single",
  Top = "sportEventsNew.top",
  Count = "sportEventsNew.count",
  MatchSuspensions = "sportEventsNew.matchSuspensions",
}
